document.addEventListener("DOMContentLoaded", () => {
  const inquiryForm = document.getElementById("inquiry-general");
  const inquiryAlt = document.getElementById("inquiry-pack_move");
  const cartForm = document.querySelector("form.cart");
  const cartButton = document.querySelector("button[name='add-to-cart']");
  const cartTotals = document.querySelector(".wapf-product-totals");
  const packMoveSelector = document.querySelectorAll('.pack_move input');
  const stairSelector = document.querySelector('.stair_count > .wapf-field-input > select');
  const modelSelector = document.querySelectorAll('.model_select > .wapf-field-input > select');
  const formReturn = document.getElementById('back-to-form');
  const formReturnAlt = document.getElementById('back-to-form_0');
  const fieldMaxLengths = {
    'email': 60,
    'shipping-first_name': 30,
    'shipping-last_name': 30,
    'shipping-address_1': 30,
    'shipping-address_2': 30,
    'shipping-city': 20,
    'shipping-postcode': 10,
    'shipping-full-name': 60, // if you're using a custom full name field
    //billing fields
    'billing-first_name': 30,
    'billing-last_name': 30,
    'billing-address_1': 30,
    'billing-address_2': 30,
    'billing-city': 20,
    'billing-postcode': 10,
    'billing_note': 500, //this ID gets added by the function below
    'billing-full-name': 60, // if you're using a custom full name field
  };

  function applyInputLimits() {
    Object.entries(fieldMaxLengths).forEach(([fieldId, maxLength]) => {
      const input = document.querySelector(`#${fieldId}`);
      if (input && !input.dataset.hasLimiter) {
        input.addEventListener('input', (e) => {
          if (e.target.value.length > maxLength) {
            e.target.value = e.target.value.slice(0, maxLength);
          }
        });
        input.dataset.hasLimiter = 'true'; // avoid re-adding listener
      }
    });
  }

  //add observer for shadow dom content
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
        const targetElement = document.querySelector('#shipping-postcode');
        const notesCheck = document.querySelector('#checkbox-control-1');
        const termsBlock = document.querySelector("form > div.wp-block-woocommerce-checkout-terms-block");
        if (targetElement) {
            //console.log(targetElement); // Found the dynamically added element
            //automatically add the stored zip code from the product page to the shipping zip on the checkout page
            sessionStorage.getItem("inst_zip") != "" ? targetElement.value = sessionStorage.getItem("inst_zip") || targetElement.setAttribute("value", sessionStorage.getItem("inst_zip")) : "";
            observer.disconnect(); // Stop observing if not needed further
        }
        if (notesCheck) {
          //console.log(notesCheck); // Found the dynamically added element
          observer.disconnect(); // Stop observing if not needed further
        }
        if (termsBlock) {
          //console.log(termsBlock)
          observer.disconnect(); // Stop observing if not needed further
        }
        applyInputLimits();
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  // Start observing the checkout root element
  const interval = setInterval(() => {
    const checkoutRoot = document.querySelector('.wc-block-checkout__main');
    if (checkoutRoot) {
      observer.observe(checkoutRoot, {
        childList: true,
        subtree: true,
      });
      applyInputLimits();
      clearInterval(interval); // stop retrying once attached
    } else {
      observer.disconnect();
      clearInterval(interval); // stop retrying if no checkout block found
      console.log('checkout not found');
    }
  }, 1000);

  //scope for checkout that shipping postcode matches postcode from local store, added on quote
  document.body.addEventListener('focusout', function (event) {
    if (event.target.matches('#shipping-postcode')) {
      if (event.target.value != sessionStorage.getItem("inst_zip")) {
        alert('Shipping ZIP Code must match zip code of installation address')
      }
    }
  });

  document.body.addEventListener('click', function (event) {
    console.log(event.target)
    if(event.target.id == "checkbox-control-0") {
      setTimeout(() => {  
        //console.log('clicked on the billing checkbox');
        applyInputLimits();
      }, 1000); // Delay to ensure block is loaded
    }
    if(event.target.checked) {
      setTimeout(() => {
        let orderNote = document.querySelector('.wc-block-checkout__add-note textarea.wc-block-components-textarea');
        if (orderNote) {
          //console.log(orderNote)
          orderNote.setAttribute("id", "billing_note")
          orderNote.setAttribute("placeholder", "Please provide any special instructions, requests, or details about your installation site (e.g., access instructions, preferred installation time, or product details).")
          applyInputLimits();
        }
      }, 300); // Delay to ensure block is loaded
    }
  });

  setTimeout(() => {
    const termsBlock = document.querySelector("form.wc-block-checkout__form > div.wp-block-woocommerce-checkout-terms-block");
    //console.log(termsBlock)
    termsBlock.innerHTML = 'By proceeding with your purchase you agree to our <a href="https://pureinstall.com/therapeutic-equipment-terms-and-conditions/" target="_blank">Terms and Conditions</a> and <a href="/privacy-policy/" target="_blank">Privacy Policy</a>';
  }, 1000); // Delay to ensure block is loaded

  


  packMoveSelector.forEach(radio => {
    radio.addEventListener("change", (event) => {
      if (event.target.value === "0kxzs" && event.target.checked) {
        inquiryAlt.classList.remove('hidden')
        cartForm.classList.add('hidden')
      }
      else {
        inquiryAlt.classList.add('hidden')
        cartForm.classList.remove('hidden')
      }
    });
  });

  const zipInputs = document.querySelectorAll('.zipsearch input');
  zipInputs.forEach(input => {
    input.addEventListener("input", (event) => {
      event.target.value = event.target.value.replace(/[^0-9]/g, '');
      if (event.target.value.length === 5) {
        runZipsearch(event);
      }
    });
  });
  // zipInputs.forEach(input => {
  //   input.addEventListener('focusout', runZipsearch);
  // });

  //monitor photo upload amount of files
  const uploadField = document.querySelector('.photo-upload input');
    uploadField.addEventListener('change', (event) => {
      const files = event.target.files;
      // Check the number of selected files
      if (files.length > 10) {
          alert('You can only upload a maximum of 10 images.');
          //uploadField.value = ''; // Clear the input
      }
    });


  //eval for extended carry stair count, if selected show inquiry form
  stairSelector.addEventListener('change', (event) => {
    console.log(event.target.value)
    if (event.target.value === "f2cpf" || event.target.value === "xz83t" || event.target.value === "jzk62") {
      inquiryForm.classList.remove('hidden')
      cartForm.classList.add('hidden')
    }
  });

  modelSelector.forEach(item => {
    item.addEventListener("change", (event) => {
      if (
        //sunlighten model not found selectors
        event.target.value === "rnlb1" || event.target.value === "fehpb" || event.target.value === "9hqpj" ||
        //sunhome model not found selectors
        event.target.value === "4qig5" || event.target.value === "lnset" || event.target.value === "pw39w" ||
        //muskoka model not found selectors
        event.target.value === "vkw99" || event.target.value === "d8vcf" || event.target.value === "obmwi"
      ) {
        inquiryForm.classList.remove('hidden')
        cartForm.classList.add('hidden')
      }
    });
  });

  //toggles inquiry form with pricing options form
  formReturn.addEventListener('click', (event) => {
    console.log(event.target)

    inquiryForm.classList.add('hidden')
    cartForm.classList.remove('hidden')
  });

  formReturnAlt.addEventListener('click', (event) => {
    console.log(event.target)

    inquiryAlt.classList.add('hidden')
    cartForm.classList.remove('hidden')
  });

  // Code snippets for cost calculations in the Product fields in WP backend
  //sample cost calculator --
  //if(len([field.e233b9a]) > 0; lookuptable(sunlightenRepair; afad312; e233b9a;) + [field.e62de02]; 'NaN')

  //if(len([field.67461b5d0d6a1]) > 0; lookuptable(sunhomeSurvey; 67461b5d0d66f; 67461b5d0d6af;) - [options_total]; 'NaN')

  //if(len([field.e233b9a]) > 0; lookuptable(sunlightenSurvey; afad312; e62de02;) - [options_total]; 'NaN')

  //if(len([field.67462096e5b30]) > 0; lookuptable(muskokaSurvey; 67462096e5b1c; 67462096e5b30;) - [field.67462096e5b7b]; 'NaN')

  // muskoka debris calc
  // if( 
  //   or(
  //     [field.67462096e59a3]="Outdoor 670 Pure Cube Sauna";
  //     [field.67462096e59a3]="Outdoor 580 Pure Cube Sauna with Shower - 4 Person";
  //     [field.67462096e59a3]="Outdoor 580 Pure Cube Sauna - 5 Person";
  //     [field.67462096e59a3]="Luna - 8' x 8' Sauna";
  //     [field.67462096e59a3]="Luna - 8' x 6' Sauna";
  //     [field.67462096e59a3]="Luna - 8' x 10' Sauna with 2' Porch";
  //     [field.67462096e59a3]="Orion Sauna"
  //    );
  //    325.00; 275.00
  //   )
  
  // sunlighten debris calc
  // if( 
  //   or(
  //     [field.57117f1]="mPulse Conquer - 3 Person Capacity";
  //     [field.57117f1]="mPulse Discover - 4 Person Capacity";
  //     [field.57117f1]="mPulse Empower - 5 Person Capacity";
  //     [field.57117f1]="Signature IV - 4 Person Capacity"
  //    );
  //    325.00; 275.00
  //   )
  
  // sunhome debris calc
  // if( 
  //   or(
  //     [field.67461b5d0d576]="Solstice: 1-Person Infared Sauna";
  //     [field.67461b5d0d576]="Solstice: 2-Person Infared Sauna";
  //     [field.67461b5d0d576]="Solstice: 3-Person Infared Sauna";
  //     [field.67461b5d0d576]="Sun Home Cold Plunge with Chiller + Heater"
  //    );
  //    325.00; 275.00
  //   )

  async function runZipsearch(e) {
    const value = e.target.value.trim();
    const zipInputType = e.target.dataset;
    sessionStorage.setItem("inst_zip",value);
    //console.log(zipInputType);

    //map taskCatID to zipInputType -- pull values from WP product fields for each product
    //sunlighten install input
    let returnField = document.querySelector("input[data-field-id='3f9c03c']");
    let surchargeField = document.querySelector("input[data-field-id='ab9ffcf']");
    let congestionField = document.querySelector("input[data-field-id='5eec58a']");
    let taskCatID = '20090'
    let pricingTiers = 3; // define based on the number of available tiers in the all_lookups pricing tables
    
    //sunlighten repair input
    if (zipInputType.fieldId == "4aad8ba") {
      returnField = document.querySelector("input[data-field-id='e233b9a']");
      surchargeField = document.querySelector("input[data-field-id='e62de02']");
      congestionField = document.querySelector("input[data-field-id='6f498f5']");
      taskCatID = '20094';
      pricingTiers = 3;
    }

    //sunlighten survey input
    if (zipInputType.fieldId == "bacfe3e") {
      returnField = document.querySelector("input[data-field-id='f52ca4d']");
      surchargeField = document.querySelector("input[data-field-id='a23ccd8']");
      congestionField = document.querySelector("input[data-field-id='ecaff21']");
      taskCatID = '20019'
      pricingTiers = 2;
    }

    //sunhome install input
    if (zipInputType.fieldId == "67461b5d0d569") {
      returnField = document.querySelector("input[data-field-id='67461b5d0d585']");
      surchargeField = document.querySelector("input[data-field-id='67461b5d0d593']");
      congestionField = document.querySelector("input[data-field-id='4fd73cc']");
      taskCatID = '20090';
      pricingTiers = 2;
    }

    //sunhome repair input
    if (zipInputType.fieldId == "67461b5d0d662") {
      returnField = document.querySelector("input[data-field-id='67461b5d0d6a1']");
      surchargeField = document.querySelector("input[data-field-id='67461b5d0d6af']");
      congestionField = document.querySelector("input[data-field-id='7ac8e71']");
      taskCatID = '20094';
      pricingTiers = 3;
    }

    //sunhome survey input
    if (zipInputType.fieldId == "95ecbdb") {
      returnField = document.querySelector("input[data-field-id='64bfc4a']");
      surchargeField = document.querySelector("input[data-field-id='3534cc0']");
      congestionField = document.querySelector("input[data-field-id='c27a594']");
      taskCatID = '20019';
      pricingTiers = 2;
    }

    //muskoka install input
    if (zipInputType.fieldId == "67462096e5991") {
      returnField = document.querySelector("input[data-field-id='67462096e59b6']");
      surchargeField = document.querySelector("input[data-field-id='67462096e59c9']");
      congestionField = document.querySelector("input[data-field-id='bd321cc']");
      taskCatID = '20090';
      pricingTiers = 2;
    }

    //muskoka repair input
    if (zipInputType.fieldId == "67462096e5b0a") {
      returnField = document.querySelector("input[data-field-id='67462096e5b30']");
      surchargeField = document.querySelector("input[data-field-id='67462096e5b44']");
      congestionField = document.querySelector("input[data-field-id='027048a']");
      taskCatID = '20094';
      pricingTiers = 3;
    }

    //muskoka survey input
    if (zipInputType.fieldId == "3202475") {
      returnField = document.querySelector("input[data-field-id='e9f43fb']");
      surchargeField = document.querySelector("input[data-field-id='13f6c1c']");
      congestionField = document.querySelector("input[data-field-id='2cdf30c']");
      taskCatID = '20019';
      pricingTiers = 2;
    }

    //sample install input
    if (zipInputType.fieldId == "67b4a38fe9595") {
      returnField = document.querySelector("input[data-field-id='67b4a38fe96bc']");
      surchargeField = document.querySelector("input[data-field-id='67b4a38fe9739']");
      congestionField = document.querySelector("input[data-field-id='67b4a38fe97b5']");
      taskCatID = '20090';
      pricingTiers = 3;
    }

    //sample repair input
    if (zipInputType.fieldId == "67b4a38fea097") {
      returnField = document.querySelector("input[data-field-id='67b4a38fea190']");
      surchargeField = document.querySelector("input[data-field-id='67b4a38fea20b']");
      congestionField = document.querySelector("input[data-field-id='67b4a38fea283']");
      taskCatID = '20094';
      pricingTiers = 3;
    }

    //sample survey input
    if (zipInputType.fieldId == "67b4a38fea5e1") {
      returnField = document.querySelector("input[data-field-id='67b4a38fea6d4']");
      surchargeField = document.querySelector("input[data-field-id='67b4a38fea74d']");
      congestionField = document.querySelector("input[data-field-id='67b4a38fea7c5']");
      taskCatID = '20019';
      pricingTiers = 2;
    }


    // Validate the input: numbers only
    if (/^[0-9]+$/.test(value)) {
      // If valid, hide the error message
      //errorMessage.style.display = "none";

      try {
        // Fetch data from the API
        const response = await fetch(`https://customer.pureinstall.com/api/public/zipsearch/${value}?taskcategory=${taskCatID}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Authorization": "PI_API OqPQ6MIEv07va7nCHtgGpUb2X62AmW0Vq15fr5PAsOENxI7ptw1OiWbzHfET-PwP_aBahVbSfGoTGgpvSVD9Am6BurMsJKSITs6L5rnWvmM"
          },
        });

        // Check if the response is successful
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        console.log(data);
        console.log(pricingTiers);
        if (data.success === true && data.range <= pricingTiers) {
          returnField.value = data.range
          surchargeField.value = data.surcharge
          congestionField.value = data.congestion_zone

          returnField.setAttribute("value", data.range);
          surchargeField.setAttribute("value", data.surcharge);
          congestionField.setAttribute("value", data.congestion_zone);
        }
        // jump to inquiry form if range has no price point attached
        if (data.success === true && data.range > pricingTiers) {
          console.log("price tier not available for this zipcode - load inquiry form")
          //show inquiry form
          inquiryForm.classList.remove('hidden')
          cartForm.classList.add('hidden')
        } 
        // jump to inquiry form if data.success is false, aka user is out of range
        if (data.success === false) {
          console.log("user is out of range - load inquiry form")
          //show inquiry form
          inquiryForm.classList.remove('hidden')
          cartForm.classList.add('hidden')
        }      
      } catch (error) {
        console.error("Error fetching API:", error);
        alert("Sorry, the lookup service did not work. Please try again.");
      }
    } else {
      // If invalid, show an error message
      //errorMessage.textContent = "Invalid input. Only numbers are allowed.";
      //errorMessage.style.display = "block";
    }
  };
});
